import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PlaneTakeoff, Sparkles } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "../components/common";

/* PWA home-screen shortcut target: jumps straight to today's (or the next) trip plan. */
export default function TripToday() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [none, setNone] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get("/trips/today")
      .then((r) => {
        if (r.data.trip?.id) navigate(`/trips/${r.data.trip.id}`, { replace: true });
        else setNone(true);
      })
      .catch(() => setNone(true));
  }, [user, navigate]);

  if (authLoading) return <Spinner full />;
  if (!user) {
    return (
      <div className="max-w-xl mx-auto px-5 py-24 text-center" data-testid="trip-today-signin">
        <PlaneTakeoff className="w-10 h-10 text-primary mx-auto mb-4" />
        <h1 className="font-heading font-900 text-2xl mb-2">My Trip Today</h1>
        <p className="text-muted-foreground mb-6">Sign in to jump straight to today's trip plan.</p>
        <Link to="/login" className="inline-flex items-center gap-2 bg-primary text-white px-5 py-2.5 font-700">Sign in</Link>
      </div>
    );
  }
  if (!none) return <Spinner full />;
  return (
    <div className="max-w-xl mx-auto px-5 py-24 text-center" data-testid="trip-today-empty">
      <PlaneTakeoff className="w-10 h-10 text-primary mx-auto mb-4" />
      <h1 className="font-heading font-900 text-2xl mb-2">No trip today</h1>
      <p className="text-muted-foreground mb-6">Nothing on the calendar for today or the next 2 days. Plan something great?</p>
      <div className="flex flex-wrap justify-center gap-2">
        <Link to="/plan-ai" data-testid="trip-today-plan-ai" className="inline-flex items-center gap-2 bg-emerald-600 text-white px-5 py-2.5 font-700"><Sparkles className="w-4 h-4" /> AI Trip Planner</Link>
        <Link to="/travel-hub" data-testid="trip-today-hub" className="inline-flex items-center gap-2 border border-zinc-300 px-5 py-2.5 font-700 hover:border-primary">My Travel Hub</Link>
      </div>
    </div>
  );
}
